<template>
    <div class="home">
        <JournalSystemList v-show="listView" @newJournal="onClickNewFromList" @editJournal="onEditJournal" :scroll="corY" ref="refreshList" @backClicked="onBackChild"/>
        <JournalSystemForm v-show="formView" :journal="journal" @backClicked="onBackChild" />
    </div>
</template>

<script>
import JournalSystemList from '@/components/journal/JournalSystemList.vue'
import JournalSystemForm from '@/components/journal/JournalSystemForm.vue'
import { mapState } from 'vuex'

export default {
  name: 'JournalSystem',
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      journal: {
        id: null,
        journal_code: null,
        journal_date: null,
        ref_no: null,
        contact: null,
        journal_description: null,
        type_id: null,
        status: null,
        debit: 0,
        credit: 0,
        branch_no: null,
        details: [{
          id: null,
          journal_code: null,
          account_code: null,
          account_name: null,
          remark: null,
          debit: '0',
          credit: '0',
          outlet_code: null
        }],
        type: {
          id: null,
          name: null
        }
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  components: {
    JournalSystemList,
    JournalSystemForm
  },
  methods: {
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.journal = {
        id: null,
        journal_code: null,
        journal_date: new Date().toISOString(),
        ref_no: null,
        contact: null,
        journal_description: null,
        type_id: 'PV',
        status: null,
        debit: 0,
        credit: 0,
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        details: [{
          journal_code: null,
          account_code: null,
          account_name: null,
          remark: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          edit: false
        }],
        type: {
          id: null,
          name: null
        }
      }
    },
    onEditJournal: function (value) {
      this.journal = value
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.journal = {
        id: null,
        journal_code: null,
        journal_date: null,
        ref_no: null,
        contact: null,
        journal_description: null,
        type_id: null,
        status: null,
        debit: 0,
        credit: 0,
        branch_no: null,
        details: [{
          id: null,
          journal_code: null,
          account_code: null,
          account_name: null,
          remark: null,
          debit: '0',
          credit: '0',
          outlet_code: null
        }],
        type: {
          id: null,
          name: null
        }
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getJournalTypes')
    this.$store.dispatch('getJournalContacts')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getJournalTemplateList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
